import { render } from "./ZonasMesaList.vue?vue&type=template&id=f58be91a&scoped=true"
import script from "./ZonasMesaList.vue?vue&type=script&lang=js"
export * from "./ZonasMesaList.vue?vue&type=script&lang=js"

import "./ZonasMesaList.vue?vue&type=style&index=0&id=f58be91a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58be91a"]])

export default __exports__